import clsx from 'clsx';
import { cloneElement, isValidElement } from 'react';
import { useCssVarPx, useStickyPinned } from '../../hooks';
import styles from './StickyPanel.module.css';

export function StickyPanel({ stickyTopVar, stickyTopFallback, width, children }) {
  const stickyTopPx = useCssVarPx(stickyTopVar, stickyTopFallback);
  const { pinned, placeholderRef, panelRef, placeholderStyle, panelStyle } = useStickyPinned({
    stickyTopPx,
  });

  if (!isValidElement(children)) return null;

  return (
    <div className={clsx(styles.wrap)} style={{ width }}>
      <div
        ref={placeholderRef}
        className={clsx(styles.placeholder)}
        style={placeholderStyle}
        aria-hidden="true"
      />
      {cloneElement(children, {
        ref: panelRef,
        className: clsx(children.props.className, pinned && styles.pinned),
        style: {
          ...children.props.style,
          ...panelStyle,
          '--sticky-top-offset': `${stickyTopPx}px`,
        },
      })}
    </div>
  );
}
